import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SystemAccessService } from '../services/system-access.service';
import { MembershipService } from '../services/membership.service';
import { resolveStanding } from './standing.util';

/**
 * Admission guard for the /access-paused landing page: only a paused (deactivated)
 * member belongs on the wall — everyone else is redirected home. Admission lives
 * entirely here (never in the component): standing is unloaded on a direct load or
 * refresh, so an unawaited component check would evict the very person the page
 * exists for. Paused member-ROOTS are redirected too — the server serves roots
 * regardless of the pause, so their honest face is the full root app, not the wall.
 */
export const accessPausedGuard: CanActivateFn = async () => {
  const access = inject(SystemAccessService);
  const membership = inject(MembershipService);
  const router = inject(Router);

  // The root leg must be RESOLVED before isRoot() is trusted on a cold load.
  await access.getPrivilegeLevel();
  const standing = await resolveStanding(membership);

  return standing === 'paused' && !access.isRoot() ? true : router.createUrlTree(['/']);
};
